module.exports = __webpack_public_path__ + "img/settings.ff42a9af.png";